module.exports = __webpack_public_path__ + "static/media/roots_nutrient.c5ade8b2.png";